// @flow

import $ from 'jquery'

import OrderValidation from '../validation/OrderValidation'

export default class Dropdown {
  static _changeSelected (key: string, value: string) {
    console.log ("change selected")
    console.log (key, value)

    const display = $(`dl[data-name="${key}"] dt span`)
    const list = $(`dl[data-name="${key}"] dd ul`)
    const text = (value ? list.find(`a[data-value="${value}"]`) : list.find('a.default')).text()

    display.text(text)
    display.attr('title', text)
    display.removeClass('default')

    if (!value) {
      display.addClass('default')
    }

    localStorage.setItem(key, value)

    const $nd = $(`input[name="${key}"]`)
    $nd.val(value)

    
    setTimeout(()=> {
      if ($nd[0]) {
        if ($nd[0].dataset.trigger == "true") {
          if (value != "") {
            $nd.trigger("change")
          }
        }
      }
    },100)
    

  }

  static rebuild (key: string, options: { [string]: string }, sort: false) {
    const optionList = Object.keys(options || {})
    if (sort) {
      optionList.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      })
    }

    function esc(str) {
      return str.split('"').join('\\"')
    }

    let htmlOptions = optionList.reduce(
      (html, key) => `${html}<li><a title="${esc(options[key])}" data-value="esc(${key})">${options[key]}</a></li>`,
      ''
    )

    htmlOptions = `<li><a class="default">Bitte wählen</a></li>${htmlOptions}`

    const list = $(`dl[data-name="${key}"] dd ul`)

    list.html(htmlOptions)

    const storedValue = localStorage.getItem(key)
    const value = storedValue && optionList.includes(storedValue) ? storedValue : ''

    Dropdown._changeSelected(key, value)

    OrderValidation.setInputError(false, key)
  }

  static init () {
    // Onclick on a dropdown, toggle visibility
    $(document).on('click', 'dl.dropdown dt', function () {
      $('dl.dropdown dd ul').hide()
      $(this).next().children().toggle()
    })

    $(document).on('click', 'dl.dropdown dd ul li a', async function () {
      console.log("click dropwdown inhalt")
      const link = $(this)
      const key = link.closest('dl.dropdown').data('name')
      let value = link.data('value')

      value = value === undefined ? '' : String(value)

      Dropdown._changeSelected(key, value)

      const { success, message } = await OrderValidation.validateInput(key, value)

      console.log (success, message)
      OrderValidation.setInputError(!success, key, message)

      // Close dropdown
      link.closest('ul').hide()
    })

    $(document).bind('click', event => {
      if (!$(event.target).closest('.dropdown').length) {
        $('dl.dropdown dd ul').hide()
      }
    })
  }
}
